export const linkedinFiltersInitialState = {
  contentTagFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'contentTagFilter',
    translateKey: 'filter:contentsTag',
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'linkedin',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
  },
  seenStatusFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both',
    componentName: 'seenStatusFilter',
    translateKey: 'filter:seenStatus',
  },
  contentTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both', // both or original or repost
    platform: 'linkedin',
    componentName: 'contentTypeFilter',
    translateKey: 'filter:contentType',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'linkedin',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
  },
  wordCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'wordCloudFilter',
    translateKey: 'filter:wordCloud',
  },
  hashtagCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'hashtagCloudFilter',
    translateKey: 'filter:hashtagCloud',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    filterType: 'include',
    hasIncludeExclude: true,
    platform: 'linkedin',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'linkedin',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
